var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCykelbane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.261,9.323l.054.185A.3.3,0,0,1,6.366,9.5l-.048-.183A.37.37,0,0,1,6.261,9.323Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.358,8.557,5.216,8.4l-.076.16a2.432,2.432,0,0,1,.223.138l-.08-.067Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.491 7.746 5.516 7.773 5.562 7.677 5.491 7.746",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.914,9.081a1.64,1.64,0,1,0-.222-3.022,1.667,1.667,0,0,0-.2.12l1.14,1.069a.324.324,0,1,1-.443.473L9.043,6.648a1.64,1.64,0,0,0,.871,2.433Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.041,9.285a2.388,2.388,0,0,1,.169.262l.105-.039L6.06,9.292C6.054,9.288,6.047,9.289,6.041,9.285Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.193 8.378 5.14 8.564 5.216 8.404 5.193 8.378",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.757,6.813l.264,1.364L7.708,6.07l-.251-.249L6.665,6.6A.772.772,0,0,1,6.757,6.813Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7,10.122l.9-.341A1.617,1.617,0,0,0,4.96,9.2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.165,6.179l.962-.942-.716-.089L5.09,4.764,4.617,5.931l.051.212,1.425.207A.312.312,0,0,1,6.165,6.179Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.945,12.119a1.64,1.64,0,0,0,.881-1.733l-1.5.571a.321.321,0,0,1-.334-.064.326.326,0,0,1-.093-.327l.441-1.547a1.64,1.64,0,1,0,.608,3.1Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.624,7.9l-1.963,2.472a.288.288,0,0,1-.2.107l-2.438.176a.283.283,0,0,0-.113.033l-1.05.558a.287.287,0,0,0-.114.11l-.635,1.11a.286.286,0,0,1-.175.135L4.3,13.3l-.266.765,7.685-1.627A.286.286,0,0,0,12,12.151l2.222-4.309Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87,3.048c.069.024.228.081.522.2a7.579,7.579,0,0,1,.85.44.162.162,0,0,0,.171-.036l.151-.2a.145.145,0,0,0,.025-.1l-.005-.175-.056-.1-.1-.119L6.5,2.516l-.014-.043c-.007-.017,0-.022.017-.022l.319-.032c.091-.01.277-.038.1-.13L6.179,1.9,6.16,1.852a1.679,1.679,0,0,0-.592-.125,1.255,1.255,0,0,0-.631.2c-.059.04-.059.045-.076.114-.037.152-.087.492-.1.633a.656.656,0,0,0,.057.318A.106.106,0,0,0,4.87,3.048Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.236,12.7a2.291,2.291,0,0,0,1.2-2.545l.1-.04a.309.309,0,0,0,.131-.1c.27.055.683-.087.632-.348l-.1-.52a.321.321,0,0,0,.247-.213l.931-2.852a.26.26,0,0,0,.01-.04l.168.158A2.288,2.288,0,1,0,9.4,5.481a2.235,2.235,0,0,0-.391.248L8.233,5c-.019-.017-.044-.013-.065-.025a.312.312,0,0,0-.225-.338L6.556,4.393,5.506,3.78a1.6,1.6,0,0,0-.815-.27,2.263,2.263,0,0,0-.457.1C3.478,3.849,3.1,5.5,3.148,6.291c.026.463.219.891.715.954l.508.065a.312.312,0,0,0,.073.26l.233.252-.16.565A2.287,2.287,0,1,0,5.236,12.7Zm3.807-6.05,1.145,1.073a.324.324,0,1,0,.443-.473L9.491,6.179a1.667,1.667,0,0,1,.2-.12,1.64,1.64,0,1,1,.222,3.022,1.64,1.64,0,0,1-.871-2.433ZM6.315,9.508l-.105.039a2.113,2.113,0,0,0-1.07-.983l.509-1.091.2.025.522,2A.3.3,0,0,0,6.315,9.508ZM5.6,9.781l-.9.341L4.96,9.2A1.617,1.617,0,0,1,5.6,9.781ZM7.708,6.07,7.021,8.177,6.757,6.813A.772.772,0,0,0,6.665,6.6l.792-.776Zm-3.04.073-.051-.212L5.09,4.764l1.321.384.716.089-.962.942a.312.312,0,0,0-.072.171ZM2.743,11.391A1.64,1.64,0,0,1,4.337,9.019L3.9,10.566a.326.326,0,0,0,.093.327.321.321,0,0,0,.334.064l1.5-.571a1.64,1.64,0,0,1-3.083,1.005Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCykelbane);
export default __webpack_public_path__ + "static/media/CYKELBANE.ecdceb33595501e837e7c012e60e8479.svg";
export { ForwardRef as ReactComponent };